import { useEffect, useState } from 'react';

export type Theme = 'light' | 'dark';

function current(): Theme {
  const stored = localStorage.getItem('eb_theme');
  if (stored === 'light' || stored === 'dark') return stored;
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function useTheme() {
  const [theme, setTheme] = useState<Theme>(current);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark');
    localStorage.setItem('eb_theme', theme);
  }, [theme]);

  return {
    theme,
    toggle: () => setTheme((value) => (value === 'dark' ? 'light' : 'dark'))
  };
}
